//import core
import core from "js/site/shared/Core";

//import plugins
import {
  DatePicker as datePicker,
  Mask as mask,
} from "js/shared/plugins/Plugins";

const promises = [
  new Promise(() => core.init()),
  new Promise(() => datePicker(".datepicker")),
  new Promise(() => mask(".masked")),
];

Promise.all(promises).then(loadPlugins());

function loadPlugins() {
  console.log("All Plugins loaded");

  const filterButton = document.querySelector("button#filter-button");
  const resetButton = document.querySelector("button#reset-button");
  const endDate = document.querySelector("input#endDate");
  const startDate = document.querySelector("input#startDate");
  const category = document.querySelector("select#category");

  resetButton.addEventListener("click", function () {
    console.log("Reset form");
    window.location = "/Haberler";
  });

  filterButton.addEventListener("click", function () {
    const url = `/Haberler/${category.value}?startDate=${startDate.value.substr(
      0,
      10
    )}&endDate=${endDate.value.substr(0, 10)}`;
    window.location = url;
  });
}
